import { render } from "./LCHearder.vue?vue&type=template&id=9fa92b3c"
import script from "./LCHearder.vue?vue&type=script&lang=js"
export * from "./LCHearder.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\lift\\120.78.159.42\\lcJian\\LC特检通\\特检通\\120.78.159.42\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__